import dynamic from "next/dynamic";
const Link = dynamic(() => import("next/link"));
import { CldImage } from "next-cloudinary";
import styles from "./IconBox.module.scss";
import SectionTitle from "components/typography/SectionTitle/SectionTitle";

export default function IconBox({
  reactIcon,
  iconImage,
  iconUrl,
  iconSize,
  title,
  text,
  link,
  rel_nofollow,
  rel_sponsored,
  link_title,
  children,
  backgroundColor = "transparent",
  textColor = "var(--dark-text)",
  highlightWords,
  divider = false,
}) {
  let icon;

  if (reactIcon) {
    icon = reactIcon;
  } else if (iconImage) {
    icon = iconImage;
  } else if (iconUrl) {
    icon = (
      <CldImage
        src={iconUrl[0] === "/" ? iconUrl.slice(1, iconUrl.length) : iconUrl}
        alt={title}
        width={iconSize > 120 ? iconSize : 120}
        height={iconSize > 120 ? iconSize : 120}
      />
    );
  } else {
    icon = null;
  }

  const iconBox = (
    <div
      className={`${styles.iconBox} `}
      style={{
        color: textColor,
        backgroundColor: backgroundColor,
      }}
    >
      <div className={`${styles.label}`}>
        {icon && (
          <span
            className={`${styles.icon}`}
            style={{
              width: iconSize ?? `${iconSize}px`,
              height: iconSize ?? `${iconSize}px`,
            }}
          >
            {icon}
          </span>
        )}
        {title && (
          <span className={`${styles.title}`}>
            <SectionTitle
              color={textColor}
              title={title}
              highlightWords={highlightWords ?? null}
            ></SectionTitle>
          </span>
        )}
      </div>
      <div className={`${styles.content}`}>
        {text && <p className={`${styles.text}`}>{text}</p>}
        {children && children}
      </div>
      {divider && (
        <span
          className={`${styles.divider}`}
          style={{ background: textColor }}
        ></span>
      )}
    </div>
  );

  if (link) {
    return (
      <Link
        href={link}
        rel={rel_nofollow ? "nofollow" : rel_sponsored ? rel_sponsored : ""}
        title={link_title ? link_title : title}
      >
        {iconBox}
      </Link>
    );
  }

  return iconBox;
}
